import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { TransferBatchFileCounts } from '../../fragments/generated/TransferBatchFileCounts';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type CancelTransferBatchMutationVariables = Types.Exact<{
  input: Types.CancelTransferBatchInput;
}>;


export type CancelTransferBatchMutation = { __typename?: 'Mutation', cancelTransferBatch?: { __typename?: 'CancelTransferBatchPayload', transferBatch: { __typename?: 'TransferBatch', id: string, fileCounts?: { __typename?: 'FileCounts', canceled?: number | null, failed?: number | null, total?: number | null, uploaded?: number | null, viewable?: number | null } | null } } | null };


export const CancelTransferBatch = /*#__PURE__*/ gql`
    mutation CancelTransferBatch($input: CancelTransferBatchInput!) {
  cancelTransferBatch(input: $input) {
    transferBatch {
      ...TransferBatchFileCounts
      id
    }
  }
}
    ${TransferBatchFileCounts}` as unknown as DocumentNode<CancelTransferBatchMutation, CancelTransferBatchMutationVariables>;

          

          export const useCancelTransferBatchMutation = (options?:MutationHookOptions<CancelTransferBatchMutation, CancelTransferBatchMutationVariables>) => useMutation(CancelTransferBatch, options);
          

          export type CancelTransferBatchMutationOptions = MutationHookOptions<CancelTransferBatchMutation, CancelTransferBatchMutationVariables>;

          

          export type CancelTransferBatchMutationResult = ReturnType<typeof useCancelTransferBatchMutation>[1];

          
